<template>
  <v-navigation-drawer :value="this.getCartDrawerState" class="cartDrawer" stateless temporary app right>
    <v-dialog v-model="orderTypeCheckDialog" persistent content-class="depositStartOption orderTypeDialog" style="max-width: 360px; width: 360px;">
      <v-card class="marketWrapper"  style="max-width: 360px; width: 360px;">
        <v-container style="max-width: 360px; width: 360px;">
          <v-card-text class="textSize__16">
            Handelt es sich um eine Haupt- oder Nachbestellung?
          </v-card-text>
          <v-btn @click="setOrderType(1)"
                  class="depositResetBtn">
            Hauptbestellung
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn  @click="setOrderType(2)"
                  class="depositContBtn">
            Nachbestellung
          </v-btn>
        </v-container>
      </v-card>
    </v-dialog>
    <v-card class="three-color-grad cartDrawerWrapper">
      <v-toolbar color="transparent" elevation="0" class="cartContentHeader" height="130">
        <div style="display: flex; align-items: flex-start; justify-content: space-between; width: 100%; align-self: flex-start; padding-top: 5px;">
          <v-btn fab small class="closeCartBtn" @click="closeCartDrawer">
            <close-btn/>
          </v-btn>
          <v-toolbar-title class="pl-3 text--black" style="flex-grow: 10; text-align: left; margin-top: 5px;">
            Warenkorb
          </v-toolbar-title>
          <div v-if="getPermissions && getPermissions.indexOf('CSVIMPORT') > -1">
            <input type="file" ref="fileInput" @change="uploadFile" v-show="false"/>
            <v-btn class="textSize__16 checkOutBtn" @click="openFileSelection" :disabled="getLoadingState">
              .csv hochladen
            </v-btn>
          </div>
        </div>
        <v-text-field placeholder="Artikel suchen..." v-model="cartSearch" class="searchField" style="flex: none; height: 40px; width: 100%;" hide-details dense rounded clearable/>
      </v-toolbar>
      <v-container class="cartContentWrapper" style="margin-top: 60px;">
        <v-virtual-scroll class="cart_virtual-scroll" item-height="255" v-if="!getLoadingState && cartProducts.length > 0" :items="cartProducts" bench="1" style="padding-top: 10px;">
          <template v-slot:default="{index, item}">
          <v-card class="articleCard"
                  elevation="0"
                  v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                  light
                  :key="index"
          >
            <v-list-item three-line @click="goToArticle(item.itemNo)" :v-ripple="false">
              <v-list-item-avatar tile>
                <v-img :src="baseUrl + 'storage/webps/'+ (item.itemNo.indexOf('-') > -1 ? item.itemNo.substr(0, item.itemNo.indexOf('-')) : item.itemNo)+'.webp'"
                       lazy-src=""
                       contain
                >
                  <template v-slot:placeholder>
                    <v-skeleton-loader type="avatar" tile>

                    </v-skeleton-loader>
                  </template>
                </v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-container>
                  <v-row class="articleCard__details">
                    <v-col cols="12"
                           class="articleNameSmall textEllipsis"
                    >
                      {{ item.description }}
                    </v-col>
                    <div class="articleAdditionalInfoWrapper">
                      <v-col cols="12" v-if="renderData.cart || renderData.category || renderData.deposit" class="textSize__14 text--black pb-0 pt-2">
                        <span class="articleAdditionalInfo">Artikelnummer: {{ item.itemNo}}</span>
                      </v-col>
                    </div>
                    <v-col cols="12" v-if="item.availability === 'G' && !renderData.deposit" class="articleStatusCol">
                      <div class="articleAvailable"></div>
                      <span class="articleStatusAvailable">Artikel ist lieferbar</span>
                    </v-col>
                    <v-col cols="12" v-if="item.availability ==='R' && !renderData.deposit" class="articleStatusCol">
                      <div class="articleNotAvailable"></div>
                      <span class="articleStatusNotAvailable"
                            v-if="!item.delisted"
                      >
                        Artikel ist derzeit nicht lieferbar
                      </span>
                      <span class="articleStatusNotAvailable"
                            v-if="item.delisted"
                      >
                        Artikel ist ausgelistet
                      </span>
                    </v-col>
                    <v-col cols="12" v-if="item.availability==='Y'" class="articleStatusCol">
                      <div class="articlePending"></div>
                      <span class="articleStatusPending textEllipsis">Bestellartikel - wird nach Eintreffen automatisch ausgeliefert</span>
                    </v-col>

                    <v-col cols="9" v-if="!renderData.cart && !renderData.deposit">


                      <div class="discountRibbonWrap"
                           v-if="item.price.length > 0 && item.price[0].action === 1"
                      >
                        <div class="discountRibbon">
                        </div>
                        <div class="discountRibbonContent">
                          <span class="ribbonText">Aktion</span>
                        </div>
                      </div>

                      <span class="articlePriceMain" v-if="item.price.length > 0 && item.price[0].price > 0">{{ item.price[0].price | parsePrice }} € </span>
                      <span class="articlePriceMain" v-if="item.price.length === 0 && item.default_price.uvp > 0">{{ item.default_price.uvp | parsePrice }} € </span>
                      <span class="articlePriceUVP" v-if="item.price.length > 0 && item.price[0].uvp !== null"> UVP: {{ item.price[0].uvp | parsePrice }} € </span>
                      <span class="articlePriceUVP" v-if="item.price.length > 0 && (item.price[0].uvp === null && item.default_price.uvp >0)"> UVP: {{ item.default_price.uvp | parsePrice }} € </span>
                      <span class="articlePriceUVP" v-if="item.price.length === 0 && (item.default_price.uvp !== null && item.default_price.uvp > 0)"> UVP: {{ item.default_price.uvp | parsePrice }} € </span>
                    </v-col>

                    <v-col cols="3">
                      <addToCart :article="item" class="listAddToCartFormButton" v-if="renderData.watchlist && (item.availability === 'G' || item.availability === 'Y')"/>
                    </v-col>

                    <v-col v-if="renderData.cart" cols="12" class="articleAmountCart">
                      <v-btn @click.stop="decreaseAmount(index)" icon class="amount-control-btn first">
                        <v-icon>mdi-minus</v-icon>
                      </v-btn>
                      <!--
                      <span @click.stop="decreaseAmount(index)">
                        -
                      </span>
                      -->
                      <span v-if="item.itemNo.indexOf('-') !== -1">
                        {{ item.itemNo.substr(item.itemNo.indexOf('-')+1) * item.orderedAmount }}
                      </span>
                      <span v-else>
                        {{ item.orderedAmount }}
                      </span>
                      <span v-if="item.itemNo.indexOf('-') !== -1">
                        {{ item.orderedType | capitalize }}
                      </span>
                      <span v-else>
                        {{ item.orderedType | capitalize }}
                      </span>
                      <v-btn @click.stop="increaseAmount(index)" icon class="amount-control-btn last">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                      <!--
                      <span @click.stop="increaseAmount(index)">
                        +
                      </span>
                      -->
                    </v-col>
                    <v-col v-if="renderData.cart" cols="12" class="pa-0"  style="margin-top: 10px;">
                      <span class="articlePriceMain">{{ item.totalPriceArticle | parsePrice }} €</span>
                      <v-btn v-if="renderData.cart && !renderData.order" @click.stop="removeFromMyCart(item)" class="removeItem" style="position: relative; float: right; margin-top: -8px; margin-right: 10px; right: 0px;">
                        <TrashCan/>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-list-item-content>
            </v-list-item>
          </v-card>
          </template>


        </v-virtual-scroll>

        <div  v-if="!getLoadingState && cartProducts.length === 0" class="emptyCartInfo" style="min-width: 360px;">
          <span>
            {{ renderData.products.length > 0 && cartSearch && cartSearch.length > 0 ? 'Keine Artikel gefunden.' : 'Du hast noch keine Artikel in den Warenkorb gelegt.' }}
          </span>
        </div>

        <v-container class="lastArticlesWrapper loading" v-if="getLoadingState">

          <v-row
              class="articleCardRow"
          >
            <v-col cols="12"
                   class="articleCardCol"
                   v-for="index in 6"
                   :key="index"
            >
              <v-card class="articleCard"
                      elevation="0"
                      v-bind:class="{cartItem: renderData.cart && !renderData.order}"
                      light
              >
                <v-list-item three-line class="skeletonWrapper__li">
                  <v-skeleton-loader class="skeletonAvatar" type="avatar">

                  </v-skeleton-loader>

                  <v-list-item-content>
                    <v-container>
                      <v-row class="articleCard__details">
                        <v-col cols="12"
                               class="articleNameSmall"
                        >
                          <v-skeleton-loader type="text"/>
                        </v-col>
                        <div class="articleAdditionalInfoWrapper">
                          <v-col cols="12" class="pb-0 pt-2">
                            <v-skeleton-loader type="text"/>
                          </v-col>
                        </div>
                        <v-col cols="12" class="articleStatus">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                        <v-col cols="12" class="articleAmountCart">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                        <v-col cols="12" class="pa-0 articlePrice">
                          <v-skeleton-loader type="text"/>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-list-item-content>
                </v-list-item>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-container>
      <v-card elevation="10" class="cartBottomCard" light>
        <v-container class="cartBottomWrapper" style="height: 100%; padding-top: 25px;">
          <v-row>
            <v-col cols="12" class="textSize__14">
              Gesamtsumme:
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <span class="articlePriceMain" v-if="!getLoadingState">{{ getTotalPrice | parsePrice2Digits}} €</span>
              <span class="articlePriceUVP" v-if="!getLoadingState">netto</span>
              <v-skeleton-loader type="text" class="articlePriceMainSkeleton" v-if="getLoadingState"></v-skeleton-loader>
            </v-col>
          </v-row>
          <v-row class="pt-2">
            <v-col cols="12">
              <v-btn class="textSize__16 checkOutBtn" @click="checkout"
                     :disabled="renderData.products.length === 0"
              >
                <checkOut/>
                <span class="pl-3 text--white">
                Zur Kasse
              </span>
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-card>
  </v-navigation-drawer>
</template>

<script>
import {mapGetters, mapActions, mapMutations} from 'vuex'
import router from "@/router";
//import ProductList from "@/app/productListing/productList";
import CheckOut from "@/assets/cart/checkOut";
import CloseBtn from "@/assets/closeBtn";
import TrashCan from "@/assets/cart/trashCan";
import axios from "axios";
import { api } from "@/config/api";
export default {
name: "cartDrawer",
  components: {CloseBtn, CheckOut, TrashCan /*ProductList*/},
  data:() => {
    return {
      items: [],
      totalPrice: null,
      cartModified: false,
      // renderData: {cart: true, category: false, deposit: false, products: []},
      baseUrl: api.url,
      cartSearch: null,
      orderTypeCheckDialog: false,
      currentSelectedCartContentType: null
    }
  },

  methods: {
    ...mapActions({
      setCartDrawerState: 'setCartDrawerState',
      setCartContent: 'setCartContent',
      retrieveCartContent: 'retrieveCartContent',
      removeFromCart: 'removeFromCart',
      setLoadingState: 'setLoadingState',
      updateTotalCartPrice: 'updateTotalCartPrice',
      importCSVToCart: 'importCSVToCart',
      addToCartAction: 'addToCart'
    }),
    ...mapMutations({
      addToCart: 'addToCart'
    }),
    uploadFile(event) {
      this.setLoadingState(true)
      let file = event.target.files[0]
      let fileName = file.name
      let fileType = fileName.substr(fileName.lastIndexOf('.') + 1);
      if(fileType === 'csv' && file.type === 'text/csv') {
        const formData = new FormData()
        formData.append('file', file)
        this.$refs.fileInput.value = ''
        this.importCSVToCart(formData).then(response => {
          this.items = response.data.cartContent
          this.renderData.products = response.data.cartContent
          this.setLoadingState(false)
        })
      }
    },
    openFileSelection() {
      this.$refs.fileInput.click()
    },
    closeCartDrawer() {
      this.setCartDrawerState()
    },
    async decreaseAmount(index) {
      let item = this.cartProducts[index]
      if(item.orderedAmount === 1) {
        const price = item.totalPriceArticle
        let articleDetails = {artNr: item.itemNo}
        const snackTxt = {name: item.description, type:item.orderedType,  amount: item.orderedAmount}
        var removeData = [articleDetails, snackTxt]
        this.removeFromCart(removeData)
        this.updateTotalCartPrice(price)
        // get index of article
        const itemIndex = this.getCartContents.findIndex(el => el === item)
        this.getCartContents.splice(itemIndex, 1)
      } else {
        let articleDetails = { artNr: item.itemNo, amount: -1 }
        let snackTxt = { name: item.description }
        let addData = [articleDetails, snackTxt, true]
        const result = await this.addToCartAction(addData)
        if(result) {
          await this.retrieveCartContent()
        }
      }
    },
    async increaseAmount(index) {
      let item = this.cartProducts[index]
      let articleDetails = { artNr: item.itemNo, amount: 1 }
      let snackTxt = { name: item.description }
      let addData = [articleDetails, snackTxt, true]
      const result = await this.addToCartAction(addData)
      if(result) {
        await this.retrieveCartContent()
      }
    },
    goToArticle(artNr) {
      this.$router.push({name: 'Artikeldetails', params: {id: artNr}})
      this.setCartDrawerState()
    },

    removeFromMyCart(item) {
      const itemIndex = this.getCartContents.findIndex(el => el === item)
      const artNr = this.getCartContents[itemIndex].itemNo
      const price = this.getCartContents[itemIndex].totalPriceArticle
      var articleDetails = {artNr: artNr}
      const snackTxt = {name: this.getCartContents[itemIndex].description, type:this.getCartContents[itemIndex].orderedType, amount: this.getCartContents[itemIndex].orderedAmount}
      var removeData = [articleDetails, snackTxt]
      this.removeFromCart(removeData)
      this.updateTotalCartPrice(price)
      this.getCartContents.splice(itemIndex, 1)
    },

    loadProductImage(artNr) {
      let adjustedArtNr = null
      if (artNr.indexOf('-') === -1) {
        adjustedArtNr = artNr
      }
      else {
        adjustedArtNr = artNr.substr(0,artNr.indexOf('-'))
      }
      return 'api/pic/'+adjustedArtNr
    },

    checkout() {
      this.closeCartDrawer()
      router.push({name: 'Checkout'})
      /*
      if(!this.currentSelectedCartContentType) {
        this.orderTypeCheckDialog = true

      } else {
        this.closeCartDrawer()
        router.push({name: 'Checkout'})
      }

       */
    },
    async setOrderType(type) {
      this.orderTypeCheckDialog = false
      const result = await axios.post('/api/setCartContentType', { cartContentType: type })
      if(result.status) {
        this.closeCartDrawer()
        await router.push({ name: 'Checkout' })
      }
    }
  },

  computed: {
    ...mapGetters({
      getCartDrawerState: 'getCartDrawerState',
      getTotalPrice: 'getTotalPrice',
      getLoadingState: 'getLoadingState',
      getCartContent: 'getCartContent',
      getCartContents: 'getCartContents',
      getPermissions: 'getPermissions'
    }),

    cartProducts() {
      // search itemNo + description + title
      let products = this.renderData.products
      if(this.cartSearch && this.cartSearch?.length > 0) {
        const keywords = this.cartSearch.toLowerCase().split(/\s+/).filter(Boolean);
        products = products.filter(({ itemNo, description }) => {
          const itemNoLower = itemNo.toLowerCase();
          const descLower = description.toLowerCase();

          const itemNoMatch = keywords.some(keyword => itemNoLower.includes(keyword));
          const descriptionMatch = keywords.every(keyword => descLower.includes(keyword));

          return itemNoMatch || descriptionMatch;
        })
      }
      return products.toReversed()
    },
    renderData() {
      return {cart: true, category: false, deposit: false, products: this.getCartContents}
    }
  },

  watch: {
    getCartDrawerState: {
     async handler(state) {
        if(state) {
          const response = await this.retrieveCartContent()
          this.items = response.data.cartContent
          this.currentSelectedCartContentType = response.data.currentSelectedCartContentType
          // this.renderData.products = response.data.cartContent
          this.setLoadingState(false)

        }
        else if(!state) {
          this.setLoadingState(true)
        }
      }
    },
  }
}
</script>

<style>
  .cart_virtual-scroll {
    min-width: 360px;
    width: 100%;
  }
  .amount-control-btn.v-btn {
    background-color: red!important;
    height: 32px!important;
    min-height: 32px!important;
    width: 32px!important;
    min-width: 32px!important;
  }
  .amount-control-btn.first {
    margin-right: 10px;
  }
  .amount-control-btn.last {
    margin-left: 10px;
  }
  .articleAmountCart .removeItem {
    padding-right: 0px!important;
    bottom: 5px!important;
    position: relative!important;
    float: right!important;
  }
  .cartContentHeader .v-toolbar__content {
    flex-direction: column;
  }
  .cartDrawer .searchField .v-input__control .v-input__slot {
    padding-left: 12px;
    padding-right: 12px;
  }
  .depositStartOption.orderTypeDialog {
    max-width: 360px;
    width: 360px;
    border-radius: 26px;
  }
</style>
